import { render, staticRenderFns } from "./Ineed.vue?vue&type=template&id=14959b2d&scoped=true&"
import script from "./Ineed.vue?vue&type=script&lang=js&"
export * from "./Ineed.vue?vue&type=script&lang=js&"
import style0 from "./Ineed.vue?vue&type=style&index=0&id=14959b2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14959b2d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VIcon,VProgressCircular,VProgressLinear,VSkeletonLoader})
